import {gql} from "@apollo/client";


export const START_PAYMENT_MUTATION = gql`mutation StartPaymentMutation($input: StartPaymentInput){
    startPayment (
        input: $input
)
    {
        forwardUrl   
        iframe  
        paymentTxId
    }
}`;